/** @format */
import {
    centToDecimal,
    formatAsCurrency,
} from '@toucan/client/global/currency';
import { Market } from '@toucan/client/global/market';

import {
    ModelStockInfo,
    QueryResponse,
    SearchListingModel,
    StockInfoAPIResponse,
} from './types';

export function transformModelStockInfoResponse(
    modelStockInfoResponse: StockInfoAPIResponse,
    activeMarket: Market
): ModelStockInfo {
    const { iso: locale, currency } = activeMarket;

    const formatPrice = formatAsCurrency(locale, currency);
    const priceMinInt = parseInt(
        modelStockInfoResponse?.productPriceMinimum?.values?.[0] ?? '0'
    );
    const priceMaxInt = parseInt(
        modelStockInfoResponse?.productPriceMaximum?.values?.[0] ?? '0'
    );
    const productCount = parseInt(
        modelStockInfoResponse?.productPriceCount?.values?.[0] ?? '0'
    );

    const priceMinFloat = centToDecimal(priceMinInt);
    const priceMaxFloat = centToDecimal(priceMaxInt);

    return {
        productCount,
        priceMinFloat,
        priceMaxFloat,
        priceMin: formatPrice(priceMinFloat, { trailingZeros: false }),
        priceMax: formatPrice(priceMaxFloat, { trailingZeros: false }),
    };
}

export function transformModelIdFromSlugResponse(
    modelIdFromSlugResponse: QueryResponse<SearchListingModel>
) {
    return modelIdFromSlugResponse.results?.[0]?.modelId?.values?.[0];
}
